var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hdr-left-nav"}},[_c('button',{class:{active:_vm.cState=='患者档案'},on:{"click":_vm.jumpPatientList}},[_c('img',{attrs:{"src":"/hdr/健康档案.png","alt":""}}),_c('span',[_vm._v("患者档案")])])])}
var staticRenderFns = []

export { render, staticRenderFns }